module.exports = "<store-nav></store-nav>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/eStore/components/app/app.component.html
// module id = ./client-src/app/eStore/components/app/app.component.html
// module chunks = main